import { createStore } from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

import accountDetails from './accountDetails'
import myPlans from './myPlans'
import loginApp from './loginApp'
import productsDatas from './productsDatas'
import commonData from './commonData'
import wizardDetails from './wizardDetails'


const store = createStore({
    modules: {
        productsDatas,
        commonData,
        loginApp,
        accountDetails,
        wizardDetails,
        myPlans
    },
    // plugins: [createPersistedState()],
})

export default store
